import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 33 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "url(#a)",
      d: "M7.29 25.494a3.646 3.646 0 1 1-3.645-3.647 3.644 3.644 0 0 1 3.645 3.647m11.945-2.292a3.64 3.64 0 0 0-2.019-1.26c-1.29-.295-3.07-.75-3.739-1.894l-.155-.264c-.683-1.171-.134-2.968.219-4.274a3.65 3.65 0 0 0-1.13-3.706 3.656 3.656 0 0 0-4.794.016 3.65 3.65 0 0 0 1.527 6.28c1.306.322 3.127.741 3.805 1.905l.155.267c.683 1.171.13 2.97-.224 4.282a3.644 3.644 0 0 0 6.259 3.352c1.163-1.322 1.206-3.332.094-4.696zm12.756 0a3.65 3.65 0 0 0-2.027-1.263c-1.288-.292-3.089-.72-3.754-1.858l-.17-.292c-.676-1.156-.11-2.963.249-4.252a3.646 3.646 0 0 0-2.667-4.528c-1.29-.305-3.114-.707-3.785-1.853l-.172-.297c-.674-1.154-.11-2.95.248-4.236A3.64 3.64 0 0 0 18.791.887a3.656 3.656 0 0 0-4.793.015 3.65 3.65 0 0 0 1.56 6.288c1.287.304 3.106.709 3.774 1.852l.18.308c.673 1.15.112 2.947-.244 4.233a3.644 3.644 0 0 0 2.665 4.521c1.287.308 3.096.707 3.761 1.85l.19.325c.674 1.154.12 2.954-.238 4.242a3.643 3.643 0 0 0 6.251 3.38c1.163-1.322 1.206-3.332.094-4.696z"
    }, null, -1),
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "a",
        x1: "0",
        x2: "32.798",
        y1: "14.574",
        y2: "14.574",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", { "stop-color": "#B758F6" }),
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": "#DE5BEC"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }